import axios from "axios";
import { toast } from "react-toastify";

import AuthService from "../../../../services/auth.service";

const APP_URL = process.env.APP_URL;

export function saveReplaceMeal({
  activeMeal,
  selectedFreeMeal,
  closeReplaceModal,
  sync,
  setIsLoading1,
  handleNotfound,
}) {
  setIsLoading1(true);

  const config = {
    headers: { Authorization: `Bearer ${AuthService.getAccessToken()}` },
  };

  const body = {
    day_meal_id: activeMeal.id,
    free_meal_id: selectedFreeMeal.id,
  };

  axios
    .post(`${APP_URL}/api/v6/user-meals/update`, body, config)
    .then(function (response) {
      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      closeReplaceModal();
      sync();
    })
    .catch(function (error) {
      setIsLoading1(false);

      if (!error.response) {
        handleNotfound();

        return false;
      }

      const statusCode = error.response.status;
      switch (statusCode) {
        case 422:
          const { errors } = error.response.data;

          for (const errorsKey in errors) {
            const error = errors[errorsKey];

            toast.error(error, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
          break;

        case 401:
          AuthService.logout();
          window.location.replace("/");
          break;
        default:
          handleNotfound();

          break;
      }
    })
    .finally(() => {
      setIsLoading1(false);
    });
}
